import React, { FC } from "react";
import { Layout, Row, Menu, Col } from "antd";
import { useNavigate } from "react-router-dom";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { UIRoutes } from "../../../router";
import { useActions } from "../../../hooks/useActions";

const AppHeader: FC = () => {
  const { isAuth } = useTypedSelector((state) => state.auth);

  const navigate = useNavigate();
  const { setIsAuth } = useActions();

  return (
    <Layout.Header>
      <Row justify="end">
        <Col span={24}>
          <Menu mode="horizontal" selectable={false}>
            <Menu.Item
              key="3"
              onClick={() => {
                setIsAuth(false);
                localStorage.removeItem("48bceb9d-e1a4-4c77-9d62-9b0e9748c07e");
                localStorage.removeItem("app.Authorized");

                navigate(`/${UIRoutes.ACCOUNT}/${UIRoutes.LOGIN}`);
              }}
            >
              Log Out
            </Menu.Item>
          </Menu>
        </Col>
      </Row>
    </Layout.Header>
  );
};
export default AppHeader;
